:host {
  --item-icon-width: calc(var(--spacer) * 3);
  --item-name-font-size: var(--body-size-large);
  --item-name-font-family: var(--font-family-secondary);
  --row-border-bottom: 1px solid var(--chart-101-pressed-dividers);
  --item-name-font-weight: 400;
  --item-name-color: var(--body-text-arrows-400);
}

.row {
  display: flex;
  align-items: center;
  height: calc(var(--spacer) * 4);
  border-bottom: var(--row-border-bottom);

  .item-info {
    flex: 1;
    display: flex;
    justify-content: space-between;
    max-width: 1200px;
    min-width: 0;
    color: var(--main-titles-inputs-600);

    gz-tooltip {
      flex: 1;

      &.wrapper-tooltip {
        display: flex;
        justify-content: end;

        &.no-progress-bar {
          flex: 0;
        }
      }

      .item-name {
        display: inline;
        line-height: 17px;
        font-family: var(--item-name-font-family);
        font-size: var(--item-name-font-size);
        font-weight: var(--item-name-font-weight);
        color: var(--item-name-color);
      }
    }

    gz-progress {
      flex: 1;
      margin: 0 calc(var(--spacer) * 2);
      display: flex;
      align-items: center;
    }

    .item-severity {
      display: flex;
      gap: var(--spacer);

      .item-value {
        display: flex;
        justify-content: flex-end;
        align-items: center;
        width: calc(var(--spacer) * 4);
        font-weight: 700;
        font-family: var(--font-family-secondary-mono);
        color: var(--main-titles-inputs-600);
      }

      .item-icon {
        width: var(--item-icon-width);
        display: flex;
        align-items: center;
        justify-content: center;
      }
    }
  }
}

.gray-color::part(svgIcon) {
  color: var(--grey-layout-200-disabled);
}

.circle-icon::before {
  content: '';
  margin: 1px;
  width: calc(var(--spacer) * 1.5);
  height: calc(var(--spacer) * 1.5);
  background-color: var(--grey-layout-202-disabled-icons);
  border-radius: 50%;
}
